import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"


export default function AppInsuranceAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Insurance"
		placeholder="All insurance"
		{...props}
	/>
}